import { SearchableCombobox, TSearchable } from '@/components/base/combobox'
import { useCombobox } from '@/helpers/useCombobox'
import { Task } from '@/types'
interface Props {
  value: string
  onChange: (value: TSearchable | null) => void
  invalid: boolean
}

interface MaintenanceTypeTaskFieldItem {
  id: Task
  name: string
}

const values: MaintenanceTypeTaskFieldItem[] = [
  { id: Task.Test, name: 'Test' },
  { id: Task.Replacement, name: 'Replacement' },
]

export const Selector = ({ value, onChange, invalid }: Props) => {
  const { items } = useCombobox<MaintenanceTypeTaskFieldItem>({
    pageInfo: undefined,
    querySelected: undefined,
    queryCollection: values,
    buildSearchable: item => item
  })

  return (
    <SearchableCombobox
      data={items}
      fetchMore={() => {}}
      includeBlank={false}
      invalid={invalid}
      loading={false}
      moreToFetch={false}
      refetch={() => { }}
      searchField=""
      value={items.find(d => d.id == value) || { id: value, name: value }}
      onChange={onChange}
    />
  )
}
